// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page{align-items:center;background-color:#fff;display:flex;flex-direction:column;height:100vh;justify-content:center;margin-bottom:100px}.error-link{border:1px solid #5f5f5f;margin-top:20px}.error-link:first-letter{text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
